import Home_CreateTwwet from "./Home_CreateTweet";
import Home_TweetsSection from "./Home_TweetsSection";
import {connect} from "react-redux";
import { getSectionTitle } from "../../redux/actions/actions.js";
import React, { useEffect } from "react";

const Home = (props) => {
    useEffect(() => {
        props.onGetSectionTitle("Home")
    })

    return(
        <div className="main_content_section_home main_content_section_main">
            <Home_CreateTwwet />
            <Home_TweetsSection />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        title: state.getSectionTitle.title
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetSectionTitle: (text) => dispatch(getSectionTitle(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Home);